/**
 * Types pour le dashboard société
 * Correspondent aux DTOs de l'API NestJS
 */

export enum DashboardPeriod {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  LAST_12_MONTHS = 'last_12_months',
  ALL = 'all',
  CUSTOM = 'custom',
}

export interface DashboardFilters {
  period?: DashboardPeriod;
  startDate?: string;
  endDate?: string;
  storeIds?: string[];
  userId?: string;
  warrantyDurations?: number[];
}

export interface PeriodKpi {
  label: string;
  totalContracts: number;
  soldContracts: number;
  soldPercent: number;
  revenue: number;
  provision: number;
  averageWarrantyPrice: number;
}

export interface DashboardKpis {
  day: PeriodKpi;
  week: PeriodKpi;
  month: PeriodKpi;
  year: PeriodKpi;
  total: PeriodKpi;
}

export interface MonthGraphData {
  month: string;
  monthName: string;
  totalContracts: number;
  soldContracts: number;
  revenue: number;
}

export interface MonthlyGraphs {
  contracts: MonthGraphData[];
  revenue: MonthGraphData[];
}

export interface WarrantyDurationStats {
  duration: number;
  contractCount: number;
  averageWarrantyPrice: number;
  averageKm: number;
  averageVehiclePrice: number;
}

export interface WarrantyReport {
  byDuration: WarrantyDurationStats[];
  total: WarrantyDurationStats;
}

export interface SavKpis {
  totalSav: number;
  savGte8: number;
  savLt8: number;
  savRate: number;
  totalIndemnisation: number;
  warrantyIndemnisation: number;
  commercialIndemnisation: number;
}

export interface SavMonthData {
  month: string;
  monthName: string;
  savCount: number;
  savGte8: number;
  indemnisationAmount: number;
}

export interface TopItem {
  name: string;
  count: number;
  percentage: number;
}

export interface SavReport {
  kpis: SavKpis;
  monthlyData: SavMonthData[];
  topBrands: TopItem[];
  topModels: TopItem[];
  topPieces: TopItem[];
}

export interface StoreStats {
  storeId: string;
  storeName: string;
  totalContracts: number;
  soldContracts: number;
  soldPercent: number;
  revenue: number;
  provision: number;
  indemnisation: number;
}

export interface SocietyDashboardData {
  societyId: string;
  societyName: string;
  isRetrocessionMode: boolean;
  kpis: DashboardKpis;
  monthlyGraphs: MonthlyGraphs;
  warrantyReport: WarrantyReport;
  savReport: SavReport;
  storeStats?: StoreStats[];
}
